import * as React from 'react';
import {DefaultButton, Dropdown, PrimaryButton} from '@fluentui/react';
import { Panel } from '@fluentui/react';
import {useContext, useEffect, useState} from "react";
import {Stack} from "@fluentui/react";
import AuthContext from "../../Services/AuthContext";

function AddUserDocumentRestriction(props) {
    const [user] = useContext(AuthContext);
    const [document, setDocument] = useState('');
    const [documents, setDocuments] = useState([]);

    const _submit = (e) => {
        e.preventDefault();
        const data = {document_type_id: document.key};
        fetch(`/api/user/${props.add}/document`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddUserDocumentRestriction'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        const abortController = new AbortController();
        setDocument('');
        if (props.add) {
            async function fetchData() {
                await fetch(`/api/document`, {
                    method: 'GET',
                    signal: abortController.signal,
                    headers: {
                        'Authorization': 'Bearer ' + user.token
                    }
                }).then(res => res.json())
                    .then(data => {
                        setDocuments(data.map((item) => {
                            return {key: item.id, text: item.type};
                        }))
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
            fetchData();
        }
        return () => abortController.abort();
    }, [props.add, user.token])


    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Dodaj Ograniczenie Dokumentów"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='AddUserDocumentRestriction'>
                <Dropdown
                    label="Typ Dokumentu"
                    selectedKey={document ? document.key : undefined}
                    onChange={(e, item) => setDocument(item)}
                    placeholder="Wybierz z listy"
                    options={documents}
                />
            </form>
        </Panel>
    )
}

export default AddUserDocumentRestriction;